import React from "react"
import PropTypes from "prop-types"
import Modal from "src/components/modals/Modal"
import GlobalEscapeHandle from "src/components/GlobalEscapeHandle"
import Category from "./Category"
import { categoryData } from "./helper"
import styles from "./Category/styles.css"

const headerLabel = `Ошибки и предупреждения плана`

const ValidateModal = ({
  closeModal,
  data,
  refreshValidate,
  history,
  resourceRedirectPath,
}) => {
  const mapData = categoryData(data)
  return (
    <>
      <Modal
        title={headerLabel}
        isOpen
        buttonConf={[]}
        width={640}
        noFooter
        fullHeight
        onCancel={closeModal}
        onRefresh={refreshValidate}
      >
        <ul className={styles.UnderListStyles}>
          {mapData.map(item => (
            <Category
              data-testid={`plan-calendar-validate-${item.id}`}
              {...item}
              history={history}
              resourceRedirectPath={resourceRedirectPath}
            />
          ))}
        </ul>
      </Modal>
      <GlobalEscapeHandle onEscapePress={closeModal} />
    </>
  )
}

ValidateModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  refreshValidate: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      eventViolations: PropTypes.arrayOf(
        PropTypes.shape({
          event: PropTypes.shape({
            description: PropTypes.string.isRequired,
            endDateTime: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            eventTypeId: PropTypes.number.isRequired,
            planInfo: PropTypes.shape({
              id: PropTypes.number.isRequired,
              locked: PropTypes.bool.isRequired,
              name: PropTypes.string.isRequired,
            }),
            repeatable: PropTypes.bool.isRequired,
            startDateTime: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
          }),
          violations: PropTypes.arrayOf(
            PropTypes.shape({
              level: PropTypes.string.isRequired,
              message: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
      planViolations: PropTypes.shape({
        plan: PropTypes.shape({
          startDateTime: PropTypes.number.isRequired,
          endDateTime: PropTypes.number.isRequired,
          id: PropTypes.number.isRequired,
          locked: PropTypes.bool.isRequired,
          name: PropTypes.string.isRequired,
        }),
        violations: PropTypes.arrayOf(
          PropTypes.shape({
            level: PropTypes.string.isRequired,
            message: PropTypes.string.isRequired,
          }),
        ),
      }),
      resourceViolations: PropTypes.arrayOf(
        PropTypes.shape({
          resource: PropTypes.shape({
            description: PropTypes.string.isRequired,
            endDateTime: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            resourceTypeId: PropTypes.number.isRequired,
            planInfo: PropTypes.shape({
              id: PropTypes.number.isRequired,
              locked: PropTypes.bool.isRequired,
              name: PropTypes.string.isRequired,
            }),
            repeatable: PropTypes.bool.isRequired,
            startDateTime: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
          }),
          violations: PropTypes.arrayOf(
            PropTypes.shape({
              level: PropTypes.string.isRequired,
              message: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
    }),
  ),
}

ValidateModal.defaultProps = {
  data: [],
}

export default ValidateModal
